'use strict';

module.exports = require('./es2015');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-dates/~/es-abstract/es6.js
 ** module id = 1030
 ** module chunks = 0
 **/